import { Moon, Sun } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";
import { AUTH } from "@/constants/testIds/app";

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === "dark";
  return (
    <button
      data-testid={AUTH.themeToggle}
      onClick={toggleTheme}
      title={isDark ? "Passa al tema chiaro" : "Passa al tema scuro"}
      aria-label="Cambia tema"
      className="h-9 w-9 rounded-full hover:bg-[var(--bg-3)] flex items-center justify-center text-[var(--fg-2)] hover:text-[var(--fg-1)]"
      style={{ transition: "background-color 0.2s ease, color 0.2s ease" }}
    >
      {isDark ? <Sun size={16} strokeWidth={1.8} /> : <Moon size={16} strokeWidth={1.8} />}
    </button>
  );
}
